import React from "react"

// styles
import "@/assets/scss/pages/analytics.scss"

// providers
import { trans } from "@/_providers/Translation"

// components
import RegisteredClients from "./partials/RegisteredClients"
import ClientsByCategory from "./partials/ClientsByCategories"
import ReviewsByCategories from "./partials/ReviewsByCategories"
import TopClients from "./partials/TopClients"
import CLVForecast from "./partials/CLVForecast"
import CLVBySegments from "./partials/CLVBySegments"

function Technicians() {
  return (
    <div id="analytics-technicians">
      <div className="top-part">
        <div className="left">
          <h1 className="page-heading">{trans("nav.analytics_clients")}</h1>
          <p className="page-subheading">{trans("subheadings.analytics_clients")}</p>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="pannel">
            <RegisteredClients />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="pannel">
            <ClientsByCategory />
          </div>
        </div>
        <div className="col">
          <div className="pannel">
            <ReviewsByCategories />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="pannel">
            <TopClients />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="pannel">
            <CLVForecast /> {/*TODO*/}
          </div>
        </div>
        <div className="col">
          <div className="pannel">
            <CLVBySegments /> {/*TODO*/}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Technicians
